import { useCallback, useEffect } from 'react';

import {
  TagListSelect,
  type TagListSelectProps,
  type TagListSelectValue,
} from 'src/components/base/controls/TagListSelect/TagListSelect';
import { withField } from 'src/helpers';
import { type IWithFieldErrorProps, withFieldError } from 'src/helpers/withFieldError';
import type { IFieldProps } from 'src/types';

type TagListSelectFieldProps = IFieldProps &
  Omit<TagListSelectProps, 'onChange'> &
  Partial<Pick<TagListSelectProps, 'onChange'>> &
  Omit<IWithFieldErrorProps, 'isShowErrorMessage'>;

export const TagListSelectField = withField(
  withFieldError((props: TagListSelectFieldProps) => {
    const {
      field,
      form: { setFieldValue, setFieldTouched },
      touchOnMount,
      onChange,
      ...rest
    } = props;

    const handleChange = useCallback(
      async (value: TagListSelectValue) => {
        await setFieldValue(field.name, value, true);
        await setFieldTouched(field.name, true);

        onChange?.(value);
      },
      [field.name, setFieldValue, setFieldTouched, onChange]
    );

    // biome-ignore lint/correctness/useExhaustiveDependencies: false
    useEffect(() => {
      if (touchOnMount) {
        setTimeout(() => void setFieldTouched(field.name, true));
      }
    }, []);

    return <TagListSelect {...field} {...rest} onChange={handleChange} />;
  }),
  true
);
